<template>
  <article @click="next">
    <img class="ocean" src="../assets/lock-screen.jpg" alt="locked phone background" />
    <section class="lock-screen">
      <div class="time">{{ time }}</div>
      <div class="day">{{ todayFormatted }}</div>
    </section>
  </article>
</template>

<script>
export default {
  name: "Locked",
  data() {
    return {
      date: ``,
      time: ``,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      timeoutInit: false
    };
  },
  methods: {
    updateTime() {
      let today = new Date();
      let timeUpdate = today
        .toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })
        .slice(0, -2);

      if (timeUpdate[0] === "0") {
        this.time = timeUpdate.slice(1);
      } else {
        this.time = timeUpdate;
      }
    },
    next() {
      if (this.crash) {
        this.$router.push("/crash");
      }
    },
    routeToCall() {
      if (!this.crash && !this.timeoutInit) {
        this.timeoutInit = true;
        setTimeout(() => {
          this.$router.push(`/sos/false`);
        }, 6000);
      }
    }
  },
  mounted() {
    this.updateTime();
    setInterval(this.updateTime, 6000);
    this.date = new Date();
    this.routeToCall();
  },
  computed: {
    todayFormatted() {
      const date = new Date();
      const today = date.getDate();
      const monthIdx = date.getMonth();
      const month = this.months[monthIdx];
      const dayIdx = date.getDay();
      const day = this.days[dayIdx];
      return `${day}, ${month} ${today}`;
    },
    crash() {
      let { routeBoolean } = this.$route.params;
      if (routeBoolean === "true") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lock-screen {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  color: #fff;
  z-index: 0;
}
.ocean {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 0;
}
.time {
  font-size: 4.25rem;
  margin-top: 20%;
}
.day {
  font-size: 2rem;
}
</style>